export default {
  timeEntries: "Time Entries",
  rateLockPolicy: "Rate Lock Policy",
  rateLockPolicyDescription:
    "Controls when hourly rates are frozen on time entries.",
  rateLockAtInvoice: "At Invoice",
  rateLockAtInvoiceDescription:
    "Rates are frozen when a time entry is included in an invoice. Until then, rate changes apply retroactively.",
  rateLockAtCreation: "At Creation",
  rateLockAtCreationDescription:
    "Rates are frozen when a time entry is created. Future rate changes do not affect existing entries.",
  rateLockNone: "No Locking",
  rateLockNoneDescription:
    "Rates are always calculated dynamically. Changing a rate affects all time entries, past and future.",
  settingsUpdatedSuccessfully: "Time entry settings updated successfully",
};
